import { Controller } from '@hotwired/stimulus';

// PROTOTYPE — cycle a query param (variant or video) while preserving others.
export default class extends Controller {
  static values = {
    options: Array,
    current: String,
    basePath: String,
    param: { type: String, default: 'variant' },
    preserve: { type: Array, default: ['video', 'variant'] }
  };

  connect() {
    this.keyHandler = this.onKeydown.bind(this);
    window.addEventListener('keydown', this.keyHandler);
  }

  disconnect() {
    window.removeEventListener('keydown', this.keyHandler);
  }

  previous() {
    this.cycle(-1);
  }

  next() {
    this.cycle(1);
  }

  pick(event) {
    const next = event.currentTarget.dataset.value;
    if (!next) return;
    this.navigate(next);
  }

  cycle(delta) {
    const list = this.optionsValue;
    if (!list?.length) return;

    const idx = list.indexOf(this.currentValue);
    const nextIdx = (idx + delta + list.length) % list.length;
    this.navigate(list[nextIdx]);
  }

  navigate(next) {
    const url = new URL(this.basePathValue, window.location.origin);
    const preserve = this.preserveValue || [];
    preserve.forEach((name) => {
      if (name === this.paramValue) return;
      const value = new URL(window.location.href).searchParams.get(name);
      if (value) url.searchParams.set(name, value);
    });
    url.searchParams.set(this.paramValue, next);
    window.location.assign(url.toString());
  }

  onKeydown(event) {
    if (this.isTypingTarget(event.target)) return;
    if (this.paramValue !== 'variant') return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.previous();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.next();
    }
  }

  isTypingTarget(target) {
    if (!target) return false;
    const tag = target.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable;
  }
}
